import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Modal } from 'react-bootstrap'

import closeImg from 'Assets/x-icon-gray.svg'

import style from './style.css'

export default function SlowDownModal (props) {
  const okRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (okRef.current) {
        okRef.current.focus();
      }
    }, 0);
  }, []);
  
  return (
    <div data-test-id="slowDownModal">
      <Modal show={true} className={classnames(style.modalContainer)} data-test-id="slowDownModal">
        <div className={style.contentWrapper}>
          <Modal.Header className={classnames('modal-header', style.headerContainer)}>
            <h2 className={style.modalTitle} style={{ fontWeight: '500' }}>
              <span className={style.modalTitleText}>Slow down!</span>
              <button
                onClick={props.onClick}
                className={classnames(style.hideModal)}
                data-test-id="slowDownHideModalBtn"
              >
                <img
                  src={closeImg}
                  alt="Close message"
                />
              </button>
            </h2>
          </Modal.Header>
          <Modal.Body>
            <p className={style.content}>
              You went through that question awfully quickly. Slow down a bit and consider each question carefully.
            </p>
          </Modal.Body>
            <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
              <button
                data-test-id="slowDownModalOkBtn"
                aria-label="Close message"
                className={classnames('btn-cdl-main', style.okButton)}
                onClick={props.onClick}
                autoFocus
                ref={okRef}
              >
                OK
              </button>
            </Modal.Footer>
        </div>
      </Modal>
    </div>
  )
}

SlowDownModal.propTypes = {
  onClick: PropTypes.func.isRequired
}
